/* Alugutter Project Estimator — calculator logic, Project Basket, sharing,
   saved lists, product thumbnails, swatches and tabs.
   Loaded (deferred) by sections/Estimating_tool.liquid after
   alugutter-estimator-data.js. Depends on AG_IMAGES and AG_IMAGE_ALIAS, which
   the section renders inline from Liquid. Vanilla JS, no dependencies. */

function agShopPhone() {
  const root = document.getElementById('ag-estimator');
  return (root && root.dataset.phone) || '';
}

/* ============================================================
   SHARED UTILITIES
   ============================================================ */
function agQ(selector) { return document.querySelector(selector); }
function agQA(selector) { return document.querySelectorAll(selector); }
function agVal(selector, asNum) {
  const el = agQ(selector);
  if (!el) return asNum ? 0 : '';
  return asNum ? (parseFloat(el.value) || 0) : (el.value || '');
}
function agLeadTime(ralSel, panelId, gutterSystem) {
  /* Calculates and displays the lead time notice for a given panel.
     gutterSystem (optional): pass current gutter system value.
     Box gutters are stocked in RAL 7016 ONLY — TB is non-stock for Box.
     Moulded Ogee is made-to-order in EVERY colour → always 10 working days.
     Fascia, soffit, and copings are always MTO → call agLeadTimeMTO instead. */
  const v = agVal(ralSel);
  const el = document.getElementById(panelId);
  if (!el) return;
  if (!v) { el.style.display = 'none'; return; }
  const isBox  = (gutterSystem === 'Box');
  const isOgee = (gutterSystem === 'Moulded Ogee');
  if (isOgee) {
    /* Moulded Ogee: made-to-order in all colours (RAL 7016, TB, Other). */
    el.className = 'ag-lead-time non-stock';
    el.innerHTML = '&#9203; Made-to-order product — estimated lead time: <strong>10 working days</strong>.';
    el.style.display = 'block';
    return;
  }
  const isStock = isBox
    ? v.includes('7016')                              // Box: only RAL 7016 stocked
    : (v === 'Textured Black (TB)' || v.includes('7016')); // Other systems: TB + 7016
  el.className = 'ag-lead-time ' + (isStock ? 'stock' : 'non-stock');
  el.innerHTML = isStock
    ? '&#9989; Stocked colour — estimated lead time: <strong>5 working days</strong>.'
    : '&#9203; Non-stocked / made-to-order colour — estimated lead time: <strong>10 working days</strong>.';
  el.style.display = 'block';
}

function agLeadTimeMTO(ralSel, panelId) {
  /* Made-to-order panels (fascia, soffit, copings) are always 10 working days,
     regardless of the RAL colour selected. */
  const v = agVal(ralSel);
  const el = document.getElementById(panelId);
  if (!el) return;
  if (!v) { el.style.display = 'none'; return; }
  el.className = 'ag-lead-time non-stock';
  el.innerHTML = '&#9203; Made-to-order product — lead time: <strong>10 working days</strong>. Made-to-order items are non-returnable.';
  el.style.display = 'block';
}

/* ============================================================
   GUTTER & DOWNPIPE CALCULATOR
   ============================================================ */
const gutterCalc = (function() {
  let hasCalc = false;
  let results = [];

  function gv(sel, num) { return agVal('#panel-gutters ' + sel, num); }
  function ge(sel) { return agQ('#panel-gutters ' + sel); }
  function gea(sel) { return agQA('#panel-gutters ' + sel); }

  function getRALSuffix() {
    const v = gv('#g-ral-colour');
    if (!v) return '';
    if (v === 'Textured Black (TB)') return '-TB';
    if (v === 'Other Colour TBA') return '-TBA';
    return '-' + v.split(' ')[1];
  }

  function addItem(arr, system, key, qty, suffix) {
    if (!qty || qty <= 0) return;
    const sysData = (AG_PRODUCTS.gutter[system] || AG_PRODUCTS.downpipe[system] || {})[key];
    if (!sysData) return;
    const code = sysData.code ? sysData.code + suffix : '';
    arr.push({ code, desc: sysData.desc, quantity: qty });
  }

  function addSundry(arr, code, desc, qty) {
    if (!qty || qty <= 0) return;
    arr.push({ code, desc, quantity: qty });
  }

  function updateDownpipeOptions() {
    const gs = gv('#g-gutter-system');
    const dpSel = ge('#g-downpipe-system');
    dpSel.innerHTML = '<option value="">— Select Downpipe System —</option>';
    const options = gs === 'Box' || gs === 'Moulded Ogee'
      ? ['Flush Joint 63mm dia','Flush Joint 76mm dia','Flush Joint 72x72mm sq','Traditional 63mm dia','Traditional 76mm dia','Traditional 72x72mm sq']
      : ['Flush Joint 63mm dia','Flush Joint 76mm dia','Traditional 63mm dia','Traditional 76mm dia'];
    options.forEach(o => dpSel.appendChild(new Option(o, o)));
  }

  function updateTable() {
    const gs = gv('#g-gutter-system');
    const ds = gv('#g-downpipe-system');
    const bt = ge('.g-bracket-type');
    const savedBt = bt ? bt.value : '';

    gea('.g-gutter-lengths-row,.g-gutter-jointers-row,.g-bracket-qty-row,.g-row-angles,.g-row-angles-ogee,.g-row-outlets,.g-row-outlets-bm,.g-row-stopends,.g-row-stopends-ogee,.g-dp-row,.g-clip-qty-row,.g-row-sw-80,.g-row-sw-90,.g-row-sw-100').forEach(r => r.style.display = 'none');

    if (bt) {
      bt.innerHTML = '<option value="">— Select —</option>';
      if (gs === 'Box') {
        bt.appendChild(new Option('Directly Fixed','Directly Fixed'));
      } else if (gs) {
        ['Fascia Brackets','Side Rafter Arms','Top Rafter Arms','Rise and Fall Brackets'].forEach(o => bt.appendChild(new Option(o,o)));
        if (gs === 'Moulded Ogee') bt.appendChild(new Option('Directly Fixed','Directly Fixed'));
      }
      bt.value = savedBt;
    }

    if (gs) {
      gea('.g-gutter-lengths-row,.g-gutter-jointers-row').forEach(r => r.style.display = 'table-row');
      if (gs !== 'Box') ge('.g-bracket-qty-row').style.display = 'table-row';
      if (gs === 'Moulded Ogee') {
        gea('.g-row-angles-ogee,.g-row-stopends-ogee').forEach(r => r.style.display = 'table-row');
      } else {
        gea('.g-row-angles,.g-row-stopends').forEach(r => r.style.display = 'table-row');
      }
      // Outlets — show the row matching the selected downpipe diameter
      if (ds) {
        if (ds.includes('63mm')) {
          const r63 = ge('.g-outlets-63');
          if (r63) r63.closest('tr').style.display = 'table-row';
        } else if (ds.includes('76mm')) {
          const r76 = ge('.g-outlets-76');
          if (r76) r76.closest('tr').style.display = 'table-row';
        } else if (ds.includes('72x72mm') && (gs === 'Box' || gs === 'Moulded Ogee')) {
          const r72 = ge('.g-outlets-72x72');
          if (r72) r72.closest('tr').style.display = 'table-row';
        }
      } else {
        // No downpipe selected: show all outlet rows relevant to this gutter system
        gea('.g-row-outlets').forEach(r => r.style.display = 'table-row');
        if (gs === 'Box' || gs === 'Moulded Ogee') ge('.g-row-outlets-bm').style.display = 'table-row';
      }
      const lbl = ge('#g-gutter-lengths-label');
      if (lbl) lbl.innerHTML = (gs === 'Moulded Ogee' ? 'No. of 1.83m Lengths' : 'No. of 3m Lengths') + ' <span class="ag-auto-marker">**</span>';
    }

    if (ds) {
      gea('.g-dp-row').forEach(r => r.style.display = 'table-row');
      ge('.g-clip-qty-row').style.display = 'table-row';
      gea('.g-row-sw-80,.g-row-sw-90,.g-row-sw-100').forEach(r => r.style.display = 'none');
      if (ds.includes('63mm')) gea('.g-row-sw-80').forEach(r => r.style.display = 'table-row');
      else if (ds.includes('76mm')) gea('.g-row-sw-90').forEach(r => r.style.display = 'table-row');
      else if (ds.includes('72x72mm')) gea('.g-row-sw-100').forEach(r => r.style.display = 'table-row');
    }
  }

  function autoCalcGutterLengths() {
    const gs = gv('#g-gutter-system');
    const m = gv('.g-total-meterage', true);
    const inp = ge('.g-gutter-lengths');
    if (!inp || inp.dataset.overridden) return;
    if (!m || !gs) return;
    inp.value = Math.ceil(m / (gs === 'Moulded Ogee' ? 1.83 : 3));
    autoCalcJointers(); autoCalcBrackets();
  }

  function autoCalcJointers() {
    const gs = gv('#g-gutter-system');
    const inp = ge('.g-gutter-jointers');
    if (!inp || inp.dataset.overridden) return;
    const gl = gv('.g-gutter-lengths', true);
    let val = 0;
    if (gs === 'Moulded Ogee') val = Math.ceil(gl / 10);
    else if (gs === 'Half Round' || gs === 'Deepflow') val = gl;
    else if (gs === 'Box') {
      const o63 = gv('.g-outlets-63',true), o76 = gv('.g-outlets-76',true), o72 = gv('.g-outlets-72x72',true);
      const a90 = gv('.g-angles-90',true), a135 = gv('.g-angles-135',true);
      val = gl + (o63+o76+o72)*2 + a90 + a135;
    }
    inp.value = val;
  }

  function autoCalcBrackets() {
    const gs = gv('#g-gutter-system');
    const bt = gv('.g-bracket-type');
    const inp = ge('.g-bracket-qty');
    if (!inp || inp.dataset.overridden || !bt) return;
    const gl = gv('.g-gutter-lengths',true);
    const m = gv('.g-total-meterage',true);
    const a90 = gv('.g-angles-90',true), a135 = gv('.g-angles-135',true);
    const a90e = gv('.g-angles-90-ext',true), a90i = gv('.g-angles-90-int',true);
    const a135e = gv('.g-angles-135-ext',true), a135i = gv('.g-angles-135-int',true);
    const o63 = gv('.g-outlets-63',true), o76 = gv('.g-outlets-76',true), o72 = gv('.g-outlets-72x72',true);
    let val = 0;
    if (bt === 'Fascia Brackets') {
      if (gs === 'Half Round' || gs === 'Deepflow') val = (gl*3) + a90 + a135 + o63 + o76;
      else if (gs === 'Moulded Ogee') val = (gl*2) + a90e+a90i+a135e+a135i + o63+o76+o72;
    } else if (bt === 'Directly Fixed' && gs === 'Moulded Ogee') {
      val = (gl*3) + a90e+a90i+a135e+a135i + o63+o76+o72;
    } else if (['Side Rafter Arms','Top Rafter Arms','Rise and Fall Brackets'].includes(bt)) {
      val = Math.ceil(m / 0.6);
      if (gs !== 'Moulded Ogee') val += a90+a135+o63+o76 + (gs==='Box'?o72:0);
      else val += a90e+a90i+a135e+a135i+o63+o76+o72;
    }
    inp.value = Math.ceil(val);
  }

  function autoCalcClips() {
    const ds = gv('#g-downpipe-system');
    const ct = gv('.g-clip-type');
    const inp = ge('.g-clip-qty');
    if (!inp || inp.dataset.overridden || !ds || !ct) return;
    const dl = gv('.g-dp-lengths',true);
    const b925 = gv('.g-bends-925',true), b1125 = gv('.g-bends-1125',true);
    const br925 = gv('.g-branches-925',true), br1125 = gv('.g-branches-1125',true);
    const shoes = gv('.g-shoes',true);
    const bends = b925+b1125+br925+br1125;
    let val = 0;
    if (ds.includes('Flush Joint')) val = (dl*2) + bends + shoes;
    else val = dl;
    inp.value = val;
  }

  function checkRecalc() {
    if (!hasCalc) return;
    ge('#g-recalc').style.display = 'block';
    ge('#g-calc-btn').classList.add('ag-btn-flash');
  }

  function validateAndCalculate() {
    const gs = gv('#g-gutter-system');
    const ral = gv('#g-ral-colour');
    const err = ge('#g-error');
    const ds = gv('#g-downpipe-system');
    if (!gs && !ds) { err.textContent = 'Please select a gutter system, a downpipe system, or both.'; err.style.display = 'block'; return; }
    if (!ral) { err.textContent = 'Please select a RAL colour before calculating.'; err.style.display = 'block'; return; }
    err.style.display = 'none';
    ge('#g-recalc').style.display = 'none';
    ge('#g-calc-btn').classList.remove('ag-btn-flash');
    hasCalc = true;
    calculate();
    ge('#g-results').style.display = 'block';
    ge('#g-results').scrollIntoView({ behavior:'smooth' });
  }

  function calculate() {
    const gs = gv('#g-gutter-system');
    const ds = gv('#g-downpipe-system');
    const suffix = getRALSuffix();
    results = [];

    if (gs) {
      const gl = gv('.g-gutter-lengths',true);
      addItem(results, gs, 'Gutter Lengths', gl, suffix);
      addItem(results, gs, 'Gutter Jointers', gv('.g-gutter-jointers',true), suffix);
      const bt = gv('.g-bracket-type');
      if (bt) addItem(results, gs, bt, gv('.g-bracket-qty',true), suffix);

      if (gs === 'Moulded Ogee') {
        ['90° External Angles','90° Internal Angles','135° External Angles','135° Internal Angles','63mm Dia Outlets','76mm Dia Outlets','72x72mm Outlets'].forEach((k,i) => {
          const vals = [gv('.g-angles-90-ext',true),gv('.g-angles-90-int',true),gv('.g-angles-135-ext',true),gv('.g-angles-135-int',true),gv('.g-outlets-63',true),gv('.g-outlets-76',true),gv('.g-outlets-72x72',true)];
          addItem(results, gs, k, vals[i], suffix);
        });
        addItem(results, gs, 'L/Hand Stop Ends', gv('.g-stop-ends-lhand',true), suffix);
        addItem(results, gs, 'R/Hand Stop Ends', gv('.g-stop-ends-rhand',true), suffix);
      } else {
        addItem(results, gs, '90° Angles', gv('.g-angles-90',true), suffix);
        addItem(results, gs, '135° Angles', gv('.g-angles-135',true), suffix);
        addItem(results, gs, '63mm Dia Outlets', gv('.g-outlets-63',true), suffix);
        addItem(results, gs, '76mm Dia Outlets', gv('.g-outlets-76',true), suffix);
        if (gs === 'Box') addItem(results, gs, '72x72mm Outlets', gv('.g-outlets-72x72',true), suffix);
        addItem(results, gs, 'Stop Ends', gv('.g-stop-ends',true), suffix);
      }
    }

    if (ds) {
      addItem(results, ds, 'Downpipe Lengths', gv('.g-dp-lengths',true), suffix);
      const ct = gv('.g-clip-type');
      const clipMap = {'Downpipe Clip (30mm standoff)':'Downpipe Clips','Adj. Pipe Clip (30-100mm)':'Adjustable Downpipe Clips'};
      if (ct && clipMap[ct]) addItem(results, ds, clipMap[ct], gv('.g-clip-qty',true), suffix);

      const swMap = {
        '63mm':[['Offset Swanneck 80-250mm','.g-sw-80-250'],['Offset Swanneck 80-500mm','.g-sw-80-500'],['Offset Swanneck 80-1000mm','.g-sw-80-1000']],
        '76mm':[['Offset Swanneck 90-250mm','.g-sw-90-250'],['Offset Swanneck 90-500mm','.g-sw-90-500'],['Offset Swanneck 90-1000mm','.g-sw-90-1000']],
        '72x72mm':[['Offset Swanneck 100-250mm','.g-sw-100-250'],['Offset Swanneck 100-500mm','.g-sw-100-500'],['Offset Swanneck 100-1000mm','.g-sw-100-1000']]
      };
      for (const [tag, items] of Object.entries(swMap)) {
        if (ds.includes(tag)) items.forEach(([key,sel]) => addItem(results, ds, key, gv(sel,true), suffix));
      }

      ['Downpipe Bends 92.5°','Downpipe Bends 112.5°','Downpipe Branches 92.5°','Downpipe Branches 112.5°','Access Plates','Shoes','Hopper Heads'].forEach((k,i) => {
        const sels = ['.g-bends-925','.g-bends-1125','.g-branches-925','.g-branches-1125','.g-access-plates','.g-shoes','.g-hoppers'];
        addItem(results, ds, k, gv(sels[i],true), suffix);
      });
    }

    // Sundry — runs for gutter-only, downpipe-only and combined take-offs.
    if (gs || ds) {
      const gl = gs ? gv('.g-gutter-lengths',true) : 0;
      const a90 = !gs ? 0 : gs==='Moulded Ogee' ? gv('.g-angles-90-ext',true)+gv('.g-angles-90-int',true)+gv('.g-angles-135-ext',true)+gv('.g-angles-135-int',true) : gv('.g-angles-90',true)+gv('.g-angles-135',true);
      const outlets = !gs ? 0 : gv('.g-outlets-63',true)+gv('.g-outlets-76',true)+(gs==='Box'||gs==='Moulded Ogee'?gv('.g-outlets-72x72',true):0);
      const stops = !gs ? 0 : gs==='Moulded Ogee' ? gv('.g-stop-ends-lhand',true)+gv('.g-stop-ends-rhand',true) : gv('.g-stop-ends',true);
      const dl = gv('.g-dp-lengths',true);
      const bends = gv('.g-bends-925',true)+gv('.g-bends-1125',true)+gv('.g-branches-925',true)+gv('.g-branches-1125',true);
      const sealantItems = gl+a90+outlets+stops+dl+bends+gv('.g-shoes',true);
      addSundry(results, 'SU1', 'TUBE OF LOW MODULUS SILICONE SEALANT (380ml)', Math.ceil(sealantItems/20));

      const bq = gv('.g-bracket-qty',true);
      const bt = gv('.g-bracket-type');
      if (gs && gs !== 'Box' && bt !== 'Directly Fixed') addSundry(results, 'SU3', 'GUTTER BRACKET FIXING SCREWS (QTY 100)', Math.ceil((bq*2)/100));
      if (gs === 'Moulded Ogee' && bt === 'Directly Fixed') addSundry(results, 'SU4', 'MOULDED GUTTER FIXING SCREWS (QTY 100)', Math.ceil(bq/100));
      if (gs === 'Moulded Ogee') addSundry(results, 'SU5', 'MOULDED GUTTER M6 JOINT NUT, BOLT AND WASHER SET (QTY 100)', Math.ceil(gv('.g-gutter-jointers',true)/100));
      if (gs === 'Box') addSundry(results, 'SU10', 'BOX GUTTER FIXING SCREWS & WASHERS (QTY 100)', Math.ceil((gl*5)/100));

      // Touch up paint
      if (suffix) {
        const ralCode = suffix === '-TB' ? '9005' : suffix === '-TBA' ? 'TBA' : suffix.slice(1);
        const su6Code = 'SU6-' + ralCode;
        results.push({ code: su6Code, desc: 'TOUCH UP PAINT (125ml) (' + gv('#g-ral-colour') + ')', quantity: 1 });
      }

      if (ds) {
        const clipQty = gv('.g-clip-qty',true);
        const hoppers = gv('.g-hoppers',true);
        if (ds.includes('Flush Joint')) addSundry(results, 'SU9', 'PIPE FIXING SCREWS (QTY 50)', Math.ceil(((clipQty*2)+(hoppers*2))/50));
        else addSundry(results, 'SU9', 'PIPE FIXING SCREWS (QTY 50)', Math.ceil((dl*2+clipQty*2+gv('.g-shoes',true)*2+hoppers*2)/50));
      }
    }

    renderResults();
    agUpdateBadge('badge-gutters', results.length);
  }

  function renderResults() {
    agMakeResultHTML(results, 'g-results-tbody', 'gutterCalc.deleteItem');
    const tba = ge('#g-tba-note');
    if (tba) tba.style.display = gv('#g-ral-colour') === 'Other Colour TBA' ? 'block' : 'none';
  }

  return {
    init() {
      updateDownpipeOptions();
      ge('#g-gutter-system').addEventListener('change', () => { updateDownpipeOptions(); autoCalcGutterLengths(); autoCalcBrackets(); checkRecalc(); updateTable(); agLeadTime('#g-ral-colour','gutter-lead-time', gv('#g-gutter-system')); });
      ge('#g-downpipe-system').addEventListener('change', () => { autoCalcClips(); updateTable(); checkRecalc(); });
      ge('#g-ral-colour').addEventListener('change', () => { checkRecalc(); agLeadTime('#g-ral-colour','gutter-lead-time', gv('#g-gutter-system')); });
      ge('.g-total-meterage').addEventListener('input', e => { e.target.value = e.target.value.replace(/[^0-9.]/g,'').replace(/\.(?=.*\.)/g,''); autoCalcGutterLengths(); checkRecalc(); });
      ge('.g-gutter-lengths').addEventListener('input', e => { e.target.value = e.target.value.replace(/[^0-9]/g,''); e.target.dataset.overridden='true'; autoCalcJointers(); autoCalcBrackets(); checkRecalc(); });
      ge('.g-gutter-jointers').addEventListener('input', e => { e.target.value = e.target.value.replace(/[^0-9]/g,''); e.target.dataset.overridden='true'; checkRecalc(); });
      ge('.g-bracket-type').addEventListener('change', () => { autoCalcBrackets(); updateTable(); checkRecalc(); });
      ge('.g-bracket-qty').addEventListener('input', e => { e.target.value = e.target.value.replace(/[^0-9]/g,''); e.target.dataset.overridden='true'; checkRecalc(); });
      ge('.g-clip-type').addEventListener('change', () => { autoCalcClips(); checkRecalc(); });
      ge('.g-clip-qty').addEventListener('input', e => { e.target.value = e.target.value.replace(/[^0-9]/g,''); e.target.dataset.overridden='true'; checkRecalc(); });
      gea('.g-row-angles input,.g-row-angles-ogee input,.g-row-outlets input,.g-row-outlets-bm input,.g-row-stopends input,.g-row-stopends-ogee input').forEach(inp => inp.addEventListener('input', e => { e.target.value = e.target.value.replace(/[^0-9]/g,''); autoCalcJointers(); autoCalcBrackets(); checkRecalc(); }));
      gea('.g-dp-row input').forEach(inp => inp.addEventListener('input', e => { e.target.value = e.target.value.replace(/[^0-9]/g,''); autoCalcClips(); checkRecalc(); }));
    },
    validateAndCalculate, calculate,
    deleteItem(i) { results.splice(i,1); renderResults(); agUpdateBadge('badge-gutters', results.length); },
    resetForm() {
      gea('input,select').forEach(el => { el.value = ''; delete el.dataset.overridden; });
      ge('#g-results').style.display = 'none'; ge('#g-recalc').style.display = 'none';
      ge('#g-calc-btn').classList.remove('ag-btn-flash'); ge('#g-error').style.display = 'none';
      ge('#gutter-lead-time').style.display = 'none';
      hasCalc = false; results = []; updateTable(); agUpdateBadge('badge-gutters', 0);
    },
    addToBasket() { if (results.length) { agBasket.addItems('gutters', results, { ral: gv('#g-ral-colour'), system: gv('#g-gutter-system') }); } },
    printResults() {
      var rows = results.map(r => '<tr><td>' + (r.code||'') + '</td><td>' + r.desc + '</td><td>' + r.quantity + '</td></tr>').join('');
      var html = '<!DOCTYPE html><html lang="en"><head><meta charset="utf-8"><title>Gutter & Downpipe Parts List</title>'
               + '<style>body{font-family:Arial;font-size:11pt;padding:20px} table{width:100%;border-collapse:collapse} th,td{border:1px solid #ccc;padding:6px;text-align:left} th{background:#f0f0f0}</style>'
               + '</head><body><h2>Alugutter — Gutter &amp; Downpipe Parts List</h2>'
               + '<table><tr><th>Code</th><th>Description</th><th>Qty</th></tr>' + rows + '</table>'
               + '<p style="font-size:12px;color:#666">** Auto-calculated quantities are estimates. Verify against site conditions before ordering. | enquiries@alugutter.co.uk</p>'
               + '</body></html>';
      var blob = new Blob([html], { type: 'text/html; charset=utf-8' });
      var url  = URL.createObjectURL(blob);
      var w    = window.open(url, '_blank', 'width=800,height=600');
      w.addEventListener('load', function() { w.print(); URL.revokeObjectURL(url); });
    },
    getResults() { return results; }
  };
})();


/* ============================================================
   FASCIA & SOFFIT CALCULATOR
   ============================================================ */
const fasciaCalc = (function() {
  let hasCalc = false;
  let results = [];

  const fasciaSizes = { "L Return":[150,210,335,460], "V Return":[165,250,325,450], "U Return":[150,235,310,435] };
  const soffitWidths = [180, 365, 490, 740];
  const fasciaAdj = { "L Return":4, "V Return":30, "U Return":30 };

  function fv(sel, num) { return agVal('#panel-fascia ' + sel, num); }
  function fe(sel) { return agQ('#panel-fascia ' + sel); }
  function fea(sel) { return agQA('#panel-fascia ' + sel); }

  function getRALSuffix() {
    const v = fv('#f-ral-colour');
    if (!v) return '';
    if (v === 'Textured Black (TB)') return '-TB';
    if (v === 'Other Colour TBA') return '-TBA';
    return '-' + v.split(' ')[1];
  }

  function getNextSize(arr, val) { return arr.find(s => s >= val) || arr[arr.length-1]; }

  function getAdjustedDepth(type) {
    const d = fv('#f-fascia-depth', true);
    return d ? d + (fasciaAdj[type] || 0) : 0;
  }

  function checkExceedance() {
    const ft = fv('#f-fascia-type'); const fw = fv('#f-soffit-width',true);
    const fd = fv('#f-fascia-depth',true);
    const fasciaNote = fe('#f-fascia-exceed'); const soffitNote = fe('#f-soffit-exceed');
    if (fasciaNote) {
      const maxFascia = ft && fasciaSizes[ft] ? fasciaSizes[ft][fasciaSizes[ft].length-1] : 999;
      fasciaNote.style.display = (ft && fd && getAdjustedDepth(ft) > maxFascia) ? 'block' : 'none';
    }
    if (soffitNote) {
      soffitNote.style.display = (fw && fw > soffitWidths[soffitWidths.length-1]) ? 'block' : 'none';
    }
  }

  function autoCalcFascia() {
    const m = fv('.f-fascia-meterage', true);
    const boards = fe('.f-fascia-boards'); const joints = fe('.f-fascia-joints');
    if (m > 0) {
      if (boards && !boards.dataset.overridden) boards.value = Math.ceil(m/3);
      if (joints && !joints.dataset.overridden) { const b = boards ? parseInt(boards.value)||0 : Math.ceil(m/3); joints.value = b; }
    }
  }

  function autoCalcSoffit() {
    const m = fv('.f-soffit-meterage', true);
    const boards = fe('.f-soffit-boards'); const joints = fe('.f-soffit-joints');
    if (m > 0) {
      if (boards && !boards.dataset.overridden) boards.value = Math.ceil(m/3);
      if (joints && !joints.dataset.overridden) { const b = boards ? parseInt(boards.value)||0 : Math.ceil(m/3); joints.value = b; }
    }
  }

  function checkRecalc() {
    if (!hasCalc) return;
    fe('#f-recalc').style.display = 'block';
    fe('#f-calc-btn').classList.add('ag-btn-flash');
  }

  function validateAndCalculate() {
    const ft = fv('#f-fascia-type'); const st = fv('#f-soffit-type'); const ral = fv('#f-ral-colour');
    const err = fe('#f-error');
    if (!ft && !st) { err.textContent = 'Please select at least a Fascia or Soffit type.'; err.style.display='block'; return; }
    if (!ral) { err.textContent = 'Please select a RAL colour before calculating.'; err.style.display='block'; return; }
    err.style.display = 'none';
    fe('#f-recalc').style.display = 'none';
    fe('#f-calc-btn').classList.remove('ag-btn-flash');
    hasCalc = true;
    calculate();
    fe('#f-results').style.display = 'block';
    fe('#f-results').scrollIntoView({ behavior:'smooth' });
  }

  function calculate() {
    const ft = fv('#f-fascia-type'); const st = fv('#f-soffit-type');
    const fd = fv('#f-fascia-depth', true); const sw = fv('#f-soffit-width', true);
    const suffix = getRALSuffix();
    results = [];

    if (ft && AG_PRODUCTS.fascia[ft]) {
      const adjDepth = getAdjustedDepth(ft);
      const sizes = fasciaSizes[ft];
      const size = adjDepth ? getNextSize(sizes, adjDepth) : sizes[0];
      const sysData = AG_PRODUCTS.fascia[ft];
      const boardData = sysData['Fascia Boards'][size];
      const numBoards = fv('.f-fascia-boards', true);
      if (numBoards > 0 && boardData) results.push({ code: boardData.code+suffix, desc: boardData.desc, quantity: numBoards });

      ['Fascia Joint Covers','External 90° Corners','Internal 90° Corners','External 135° Corners','Internal 135° Corners','Gable Box End Sections'].forEach(key => {
        const selMap = { 'Fascia Joint Covers':'.f-fascia-joints','External 90° Corners':'.f-ext-90','Internal 90° Corners':'.f-int-90','External 135° Corners':'.f-ext-135','Internal 135° Corners':'.f-int-135','Gable Box End Sections':'.f-gable-ends' };
        const qty = fv(selMap[key], true);
        if (qty > 0 && sysData[key]) results.push({ code: sysData[key].code+suffix, desc: sysData[key].desc, quantity: qty });
      });
    }

    if (st && AG_PRODUCTS.soffit[st]) {
      const size = sw ? getNextSize(soffitWidths, sw) : soffitWidths[0];
      const sysData = AG_PRODUCTS.soffit[st];
      const boardData = sysData['Soffit Boards'][size];
      const numBoards = fv('.f-soffit-boards', true);
      if (numBoards > 0 && boardData) results.push({ code: boardData.code+suffix, desc: boardData.desc, quantity: numBoards });
      const jointQty = fv('.f-soffit-joints', true);
      if (jointQty > 0) {
        const jdata = sysData['Soffit Joint Covers']['SF1'];
        results.push({ code: jdata.code+suffix, desc: jdata.desc, quantity: jointQty });
      }
    }

    // Sundry
    const totalBoards = fv('.f-fascia-boards',true) + fv('.f-soffit-boards',true);
    if (totalBoards > 0) {
      results.push({ code:'SU1', desc:'TUBE OF LOW MODULUS SILICONE SEALANT (380ml)', quantity: Math.ceil(totalBoards/20) });
      if (suffix) {
        const ralCode = suffix === '-TB' ? '9005' : suffix === '-TBA' ? 'TBA' : suffix.slice(1);
        results.push({ code:'SU6-'+ralCode, desc:'TOUCH UP PAINT (125ml) ('+fv('#f-ral-colour')+')', quantity:1 });
        const su7Code = 'SU7' + suffix;
        /* Each 3 m fascia or soffit board takes 10 screws; SU7 is a pack of 100 (owner, 2026-09-24). */
        results.push({ code: su7Code, desc:'FASCIA/SOFFIT COLOUR MATCHED FIXING SCREW (Qty 100)', quantity: Math.ceil((totalBoards*10)/100) });
      }
    }

    renderResults();
    agUpdateBadge('badge-fascia', results.length);
  }

  function renderResults() {
    agMakeResultHTML(results, 'f-results-tbody', 'fasciaCalc.deleteItem');
    const tba = fe('#f-tba-note');
    if (tba) tba.style.display = fv('#f-ral-colour') === 'Other Colour TBA' ? 'block' : 'none';
  }

  return {
    init() {
      fe('#f-fascia-type').addEventListener('change', () => { autoCalcFascia(); checkRecalc(); checkExceedance(); agLeadTimeMTO('#f-ral-colour','fascia-lead-time'); });
      fe('#f-soffit-type').addEventListener('change', () => { autoCalcSoffit(); checkRecalc(); });
      fe('#f-ral-colour').addEventListener('change', () => { checkRecalc(); agLeadTimeMTO('#f-ral-colour','fascia-lead-time'); });
      fe('#f-fascia-depth').addEventListener('blur', checkExceedance);
      fe('#f-soffit-width').addEventListener('blur', checkExceedance);
      fe('.f-fascia-meterage').addEventListener('input', e => { e.target.value = e.target.value.replace(/[^0-9.]/g,'').replace(/\.(?=.*\.)/g,''); autoCalcFascia(); checkRecalc(); });
      fe('.f-soffit-meterage').addEventListener('input', e => { e.target.value = e.target.value.replace(/[^0-9.]/g,'').replace(/\.(?=.*\.)/g,''); autoCalcSoffit(); checkRecalc(); });
      ['.f-fascia-boards','.f-fascia-joints','.f-soffit-boards','.f-soffit-joints'].forEach(sel => {
        const el = fe(sel);
        if (el) el.addEventListener('input', e => { e.target.value = e.target.value.replace(/[^0-9]/g,''); e.target.dataset.overridden='true'; checkRecalc(); });
      });
      fea('.f-ext-90,.f-int-90,.f-ext-135,.f-int-135,.f-gable-ends').forEach(el => el.addEventListener('input', e => { e.target.value = e.target.value.replace(/[^0-9]/g,''); checkRecalc(); }));
    },
    validateAndCalculate, calculate,
    deleteItem(i) { results.splice(i,1); renderResults(); agUpdateBadge('badge-fascia', results.length); },
    resetForm() {
      fea('input,select').forEach(el => { el.value = ''; delete el.dataset.overridden; });
      fe('#f-results').style.display='none'; fe('#f-recalc').style.display='none';
      fe('#f-calc-btn').classList.remove('ag-btn-flash'); fe('#f-error').style.display='none';
      fe('#f-fascia-exceed').style.display='none'; fe('#f-soffit-exceed').style.display='none';
      fe('#fascia-lead-time').style.display='none';
      hasCalc=false; results=[]; agUpdateBadge('badge-fascia',0);
    },
    addToBasket() { if (results.length) { agBasket.addItems('fascia', results, { ral: fv('#f-ral-colour') }); } },
    printResults() {
      var rows = results.map(r => '<tr><td>' + (r.code||'') + '</td><td>' + r.desc + '</td><td>' + r.quantity + '</td></tr>').join('');
      var html = '<!DOCTYPE html><html lang="en"><head><meta charset="utf-8"><title>Fascia & Soffit Parts List</title>'
               + '<style>body{font-family:Arial;font-size:11pt;padding:20px} table{width:100%;border-collapse:collapse} th,td{border:1px solid #ccc;padding:6px;text-align:left} th{background:#f0f0f0}</style>'
               + '</head><body><h2>Alugutter — Fascia &amp; Soffit Parts List</h2>'
               + '<table><tr><th>Code</th><th>Description</th><th>Qty</th></tr>' + rows + '</table>'
               + '<p style="font-size:12px;color:#666">All fascia, soffit, and coping products are made to order and non-returnable. | enquiries@alugutter.co.uk</p>'
               + '</body></html>';
      var blob = new Blob([html], { type: 'text/html; charset=utf-8' });
      var url  = URL.createObjectURL(blob);
      var w    = window.open(url, '_blank', 'width=800,height=600');
      w.addEventListener('load', function() { w.print(); URL.revokeObjectURL(url); });
    },
    getResults() { return results; }
  };
})();


/* ============================================================
   COPING CALCULATOR
   ============================================================ */
const copingCalc = (function() {
  let hasCalc = false;
  let results = [];

  function cv(sel, num) { return agVal('#panel-copings ' + sel, num); }
  function ce(sel) { return agQ('#panel-copings ' + sel); }
  function cea(sel) { return agQA('#panel-copings ' + sel); }

  function getRALSuffix() {
    const v = cv('#c-ral-colour');
    if (!v) return '';
    if (v === 'Textured Black (TB)') return '-TB';
    if (v === 'Other Colour TBA') return '-TBA';
    return '-' + v.split(' ')[1];
  }

  function getSystem() {
    const w = cv('#c-wall-width', true);
    if (!w) return null;
    for (const [key, data] of Object.entries(AG_PRODUCTS.coping)) {
      if (w >= data.min && w <= data.max) return key;
    }
    return null;
  }

  function updateSystemNote() {
    const sys = getSystem();
    const el = ce('#c-system-note');
    const exceed = ce('#c-wall-exceed');
    if (!el) return;
    const w = cv('#c-wall-width', true);
    if (!w) { el.style.display='none'; if(exceed) exceed.style.display='none'; return; }
    if (sys) {
      const d = AG_PRODUCTS.coping[sys];
      el.textContent = `Wall width ${w}mm → Selected system: ${sys} (covers ${d.min}–${d.max}mm wall width)`;
      el.style.display = 'block';
      if (exceed) exceed.style.display = 'none';
    } else {
      el.style.display = 'none';
      if (exceed) exceed.style.display = 'block';
    }
  }

  function updateAutoCalc() {
    const m = cv('.c-total-meterage', true);
    const corners = cv('.c-corners-90',true), tj = cv('.c-tjunctions',true), se = cv('.c-stop-ends',true), seu = cv('.c-stop-upstands',true);
    const lenInp = ce('.c-lengths'); const bracInp = ce('.c-brackets');
    if (lenInp && !lenInp.dataset.overridden) {
      lenInp.value = m > 0 ? Math.ceil(m/3) : 0;
    }
    const lengths = lenInp ? parseInt(lenInp.value)||0 : 0;
    if (bracInp && !bracInp.dataset.overridden) {
      bracInp.value = Math.ceil((lengths*2) + corners + (tj*2) + se + seu);
    }
  }

  function checkRecalc() {
    if (!hasCalc) return;
    ce('#c-recalc').style.display = 'block';
    ce('#c-calc-btn').classList.add('ag-btn-flash');
  }

  function validateAndCalculate() {
    const w = cv('#c-wall-width', true); const ral = cv('#c-ral-colour');
    const err = ce('#c-error');
    if (!w) { err.textContent = 'Please enter your finished wall width.'; err.style.display='block'; return; }
    if (!getSystem()) { err.textContent = 'Wall width exceeds our standard coping range (115–420mm). Please contact us.'; err.style.display='block'; return; }
    if (!ral) { err.textContent = 'Please select a RAL colour before calculating.'; err.style.display='block'; return; }
    err.style.display = 'none';
    ce('#c-recalc').style.display = 'none';
    ce('#c-calc-btn').classList.remove('ag-btn-flash');
    hasCalc = true;
    calculate();
    ce('#c-results').style.display = 'block';
    ce('#c-results').scrollIntoView({ behavior:'smooth' });
  }

  function calculate() {
    const sys = getSystem();
    if (!sys) return;
    const suffix = getRALSuffix();
    const sysData = AG_PRODUCTS.coping[sys];
    results = [];

    const quantities = {
      'Coping Lengths': cv('.c-lengths',true),
      'Coping Brackets/Jointers': cv('.c-brackets',true),
      '90° Corners': cv('.c-corners-90',true),
      'T-Junctions': cv('.c-tjunctions',true),
      'Stop Ends': cv('.c-stop-ends',true),
      'Stop End Upstands': cv('.c-stop-upstands',true)
    };

    for (const [key, qty] of Object.entries(quantities)) {
      if (qty > 0 && sysData[key]) {
        results.push({ code: sysData[key].code + suffix, desc: sysData[key].desc, quantity: qty });
      }
    }

    // Sundry
    const totalParts = Object.values(quantities).reduce((a,b)=>a+b,0);
    results.push({ code:'SU1', desc:'TUBE OF LOW MODULUS SILICONE SEALANT (380ml)', quantity: Math.ceil(totalParts/20) });
    const bracketQty = quantities['Coping Brackets/Jointers'];
    /* Each coping bracket takes 4 screws; SU11 is a pack of 100 (owner, 2026-09-23). */
    if (bracketQty > 0) results.push({ code:'SU11', desc:'COPING BRACKET FIXING SCREW (Qty 100) - No. 10 x 24mm', quantity: Math.ceil((bracketQty*4)/100) });
    if (suffix) {
      const ralCode = suffix === '-TB' ? '9005' : suffix === '-TBA' ? 'TBA' : suffix.slice(1);
      results.push({ code:'SU6-'+ralCode, desc:'TOUCH UP PAINT (125ml) ('+cv('#c-ral-colour')+')', quantity:1 });
    }

    renderResults();
    agUpdateBadge('badge-copings', results.length);
  }

  function renderResults() {
    agMakeResultHTML(results, 'c-results-tbody', 'copingCalc.deleteItem');
    const tba = ce('#c-tba-note');
    if (tba) tba.style.display = cv('#c-ral-colour') === 'Other Colour TBA' ? 'block' : 'none';
  }

  return {
    init() {
      ce('#c-wall-width').addEventListener('input', () => { updateSystemNote(); updateAutoCalc(); checkRecalc(); });
      ce('#c-wall-width').addEventListener('blur', updateSystemNote);
      ce('#c-ral-colour').addEventListener('change', () => { checkRecalc(); agLeadTimeMTO('#c-ral-colour','copings-lead-time'); });
      ce('.c-total-meterage').addEventListener('input', e => { e.target.value = e.target.value.replace(/[^0-9.]/g,'').replace(/\.(?=.*\.)/g,''); updateAutoCalc(); checkRecalc(); });
      ce('.c-lengths').addEventListener('input', e => { e.target.value = e.target.value.replace(/[^0-9]/g,''); e.target.dataset.overridden='true'; updateAutoCalc(); checkRecalc(); });
      ce('.c-brackets').addEventListener('input', e => { e.target.value = e.target.value.replace(/[^0-9]/g,''); e.target.dataset.overridden='true'; checkRecalc(); });
      cea('.c-corners-90,.c-tjunctions,.c-stop-ends,.c-stop-upstands').forEach(el => el.addEventListener('input', e => { e.target.value = e.target.value.replace(/[^0-9]/g,''); updateAutoCalc(); checkRecalc(); }));
    },
    validateAndCalculate, calculate,
    deleteItem(i) { results.splice(i,1); renderResults(); agUpdateBadge('badge-copings', results.length); },
    resetForm() {
      cea('input,select').forEach(el => { el.value = ''; delete el.dataset.overridden; });
      ce('#c-results').style.display='none'; ce('#c-recalc').style.display='none';
      ce('#c-calc-btn').classList.remove('ag-btn-flash'); ce('#c-error').style.display='none';
      ce('#c-system-note').style.display='none'; ce('#c-wall-exceed').style.display='none';
      ce('#copings-lead-time').style.display='none';
      hasCalc=false; results=[]; agUpdateBadge('badge-copings',0);
    },
    addToBasket() { if (results.length) { agBasket.addItems('copings', results, { ral: cv('#c-ral-colour') }); } },
    printResults() {
      var rows = results.map(r => '<tr><td>' + (r.code||'') + '</td><td>' + r.desc + '</td><td>' + r.quantity + '</td></tr>').join('');
      var html = '<!DOCTYPE html><html lang="en"><head><meta charset="utf-8"><title>Wall Coping Parts List</title>'
               + '<style>body{font-family:Arial;font-size:11pt;padding:20px} table{width:100%;border-collapse:collapse} th,td{border:1px solid #ccc;padding:6px;text-align:left} th{background:#f0f0f0}</style>'
               + '</head><body><h2>Alugutter — Wall Coping Parts List</h2>'
               + '<table><tr><th>Code</th><th>Description</th><th>Qty</th></tr>' + rows + '</table>'
               + '<p style="font-size:12px;color:#666">Coping products are made to order and non-returnable. | enquiries@alugutter.co.uk</p>'
               + '</body></html>';
      var blob = new Blob([html], { type: 'text/html; charset=utf-8' });
      var url  = URL.createObjectURL(blob);
      var w    = window.open(url, '_blank', 'width=800,height=600');
      w.addEventListener('load', function() { w.print(); URL.revokeObjectURL(url); });
    },
    getResults() { return results; }
  };
})();


/* ============================================================
   CALCULATOR REGISTRY — lets delegated event handlers reach the
   module objects (top-level consts are not window properties).
   ============================================================ */
const AG_CALCS = { gutterCalc, fasciaCalc, copingCalc };

/* ============================================================
   DESCRIPTION INDEX — code base → description, built from
   AG_PRODUCTS. Used to keep share links short: an item's
   description is only carried in the link when it differs.
   ============================================================ */
const AG_DESC = (function() {
  const index = {};
  (function walk(node) {
    if (!node || typeof node !== 'object') return;
    if (typeof node.code === 'string' && typeof node.desc === 'string') { if (node.code) index[node.code] = node.desc; return; }
    Object.values(node).forEach(walk);
  })(AG_PRODUCTS);
  return index;
})();

function agEsc(s) {
  return String(s == null ? '' : s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
}

/* ============================================================
   PRODUCT IMAGES
   ============================================================ */
const AG_IMG_CACHE = {};   /* product handle → { variantId: imageUrl } */

function agCodeBase(code) { return String(code || '').replace(/-(TB|TBA|\d{4})$/, ''); }

function agImageEntry(code) {
  const b = agCodeBase(code);
  const k = AG_IMAGES[b] ? b : AG_IMAGE_ALIAS[b];
  return (k && AG_IMAGES[k]) ? { src: AG_IMAGES[k][0], handle: AG_IMAGES[k][1] } : null;
}

/* Colour suffix for a RAL select value, matching the calculators' own rule. */
function agSuffixFor(v) {
  if (!v) return '';
  if (v === 'Textured Black (TB)') return '-TB';
  if (v === 'Other Colour TBA') return '-TBA';
  return '-' + v.split(' ')[1];
}

/* Absolute URL — Liquid's image_url can return a protocol-relative URL, which
   does not resolve inside the print window's blob: document. */
function agAbsUrl(src) {
  if (!src) return '';
  if (/^\/\//.test(src)) return 'https:' + src;
  if (/^\//.test(src)) return location.origin + src;
  return src;
}

/* Finish notes for parts that are not colour matched. */
const AG_STEEL_CODES = ['SU3', 'SU4', 'SU9', 'SU10', 'SU11'];
function agItemNote(code) {
  const b = agCodeBase(code);
  if (b === 'SU1') return 'Supplied in grey regardless of the colour selected.';
  if (AG_STEEL_CODES.indexOf(b) > -1) return 'Stainless steel finish; not colour matched.';
  return '';
}
function agNoteHTML(code) {
  const n = agItemNote(code);
  return n ? '<span class="ag-cell-note">' + agEsc(n) + '</span>' : '';
}

function agSizedImg(src, px) {
  if (!src) return '';
  if (/[?&]width=\d+/.test(src)) return src.replace(/([?&])width=\d+/, '$1width=' + px);
  if (/_\d+x\d+(\.[a-z]+)(\?|$)/i.test(src)) return src.replace(/_\d+x\d+(\.[a-z]+)/i, '_' + px + 'x' + px + '$1');
  return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + px;
}

const AG_BLANK_THUMB = '<span class="ag-thumb-blank" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 16l5-5 4 4 3-3 6 6"/><circle cx="16" cy="8" r="1.5"/></svg></span>';

/* Thumbnail for a results or basket row. Opens the lightbox on click. */
function agThumbHTML(code, desc) {
  const entry = agImageEntry(code);
  if (!entry) return AG_BLANK_THUMB;
  const vid = AG_VARIANT_IDS[code] || '';
  return '<button type="button" class="ag-thumb-btn" data-action="lightbox" data-src="' + agEsc(entry.src) + '" data-handle="' + agEsc(entry.handle) + '" data-code="' + agEsc(code) + '" data-desc="' + agEsc(desc) + '" aria-label="Show image of ' + agEsc(desc) + '">'
       + '<img src="' + agEsc(entry.src) + '" alt="" loading="lazy" width="44" height="44" data-handle="' + agEsc(entry.handle) + '" data-variant="' + agEsc(vid) + '">'
       + '</button>';
}

/* After a list renders, swap generic product images for the colour-specific
   variant image where one exists. One fetch per product handle, cached. */
function agUpgradeImages(container) {
  if (!container || !/^https?:$/.test(location.protocol)) return;
  const imgs = Array.from(container.querySelectorAll('img[data-handle][data-variant]')).filter(i => i.dataset.variant && !i.dataset.upgraded);
  const byHandle = {};
  imgs.forEach(i => { (byHandle[i.dataset.handle] = byHandle[i.dataset.handle] || []).push(i); });
  Object.keys(byHandle).forEach(handle => {
    const apply = map => byHandle[handle].forEach(img => {
      const url = map[img.dataset.variant];
      img.dataset.upgraded = '1';
      if (!url) return;
      img.src = agSizedImg(url, 160);
      const btn = img.closest('[data-src]');
      if (btn) btn.dataset.src = url;
    });
    if (AG_IMG_CACHE[handle]) { apply(AG_IMG_CACHE[handle]); return; }
    fetch('/products/' + handle + '.js')
      .then(r => r.ok ? r.json() : null)
      .then(p => {
        const map = {};
        if (p && Array.isArray(p.variants)) p.variants.forEach(v => { if (v.featured_image && v.featured_image.src) map[String(v.id)] = v.featured_image.src; });
        AG_IMG_CACHE[handle] = map;
        apply(map);
      })
      .catch(() => { AG_IMG_CACHE[handle] = {}; });
  });
}

/* Thumbnails beside the measurement rows, resolved from the current
   system selections so the user sees the part before counting it. */
const agRowThumbs = (function() {
  function set(tr, d, suffix) {
    const slot = tr.querySelector('.ag-row-thumb');
    if (!slot) return;
    const entry = d && d.code ? agImageEntry(d.code) : null;
    if (!entry) { slot.innerHTML = ''; return; }
    const full = d.code + (suffix || '');
    const vid = AG_VARIANT_IDS[full] || '';
    slot.innerHTML = '<button type="button" class="ag-thumb-btn" data-action="lightbox" data-src="' + agEsc(entry.src) + '" data-handle="' + agEsc(entry.handle) + '" data-code="' + agEsc(full) + '" data-desc="' + agEsc(d.desc) + '" aria-label="Show image of ' + agEsc(d.desc) + '">'
                   + '<img src="' + agEsc(entry.src) + '" alt="" loading="lazy" width="40" height="40" data-handle="' + agEsc(entry.handle) + '" data-variant="' + agEsc(vid) + '"></button>';
  }
  function firstEntry(d) {
    /* Sized entries (fascia/soffit boards, soffit joint covers) are maps of size → item. */
    if (d && d.code === undefined) { const vals = Object.values(d); return vals.length ? vals[0] : null; }
    return d;
  }
  function gutter() {
    const gs = agVal('#g-gutter-system'), ds = agVal('#g-downpipe-system');
    const bt = agVal('#panel-gutters .g-bracket-type'), ct = agVal('#panel-gutters .g-clip-type');
    const suffix = agSuffixFor(agVal('#g-ral-colour'));
    const clipMap = { 'Downpipe Clip (30mm standoff)':'Downpipe Clips', 'Adj. Pipe Clip (30-100mm)':'Adjustable Downpipe Clips' };
    /* Downpipe-only take-off: keep the gutter table blank, as the downpipe table is when no downpipe is chosen. */
    const gTable = document.getElementById('g-gutter-table');
    if (gTable) gTable.classList.toggle('is-empty', !gs);
    agQA('#panel-gutters tr[data-item], #panel-gutters tr[data-item-from]').forEach(tr => {
      let sys, key = tr.dataset.item;
      if (tr.dataset.system === 'downpipe') { sys = AG_PRODUCTS.downpipe[ds]; if (tr.dataset.itemFrom === 'clip') key = clipMap[ct]; }
      else { sys = AG_PRODUCTS.gutter[gs]; if (tr.dataset.itemFrom === 'bracket') key = bt; }
      set(tr, sys && key ? sys[key] : null, suffix);
    });
    agUpgradeImages(document.getElementById('panel-gutters'));
  }
  function fascia() {
    const ft = agVal('#f-fascia-type'), st = agVal('#f-soffit-type');
    const suffix = agSuffixFor(agVal('#f-ral-colour'));
    agQA('#panel-fascia tr[data-item]').forEach(tr => {
      const sys = tr.dataset.system === 'soffit' ? AG_PRODUCTS.soffit[st] : AG_PRODUCTS.fascia[ft];
      set(tr, sys ? firstEntry(sys[tr.dataset.item]) : null, suffix);
    });
    agUpgradeImages(document.getElementById('panel-fascia'));
  }
  function coping() {
    const w = agVal('#c-wall-width', true);
    const suffix = agSuffixFor(agVal('#c-ral-colour'));
    let sys = null;
    if (w) for (const data of Object.values(AG_PRODUCTS.coping)) { if (w >= data.min && w <= data.max) { sys = data; break; } }
    agQA('#panel-copings tr[data-item]').forEach(tr => set(tr, sys ? sys[tr.dataset.item] : null, suffix));
    agUpgradeImages(document.getElementById('panel-copings'));
  }
  return { gutter, fascia, coping, refresh() { gutter(); fascia(); coping(); } };
})();

const agLightbox = {
  open(btn) {
    const dlg = document.getElementById('ag-lightbox');
    if (!dlg) return;
    const src = btn.dataset.src || '';
    document.getElementById('ag-lightbox-img').src = agSizedImg(src, 720);
    document.getElementById('ag-lightbox-img').alt = btn.dataset.desc || '';
    document.getElementById('ag-lightbox-desc').textContent = btn.dataset.desc || '';
    document.getElementById('ag-lightbox-code').textContent = btn.dataset.code ? 'Code: ' + btn.dataset.code : '';
    const link = document.getElementById('ag-lightbox-link');
    if (btn.dataset.handle) { link.href = '/products/' + btn.dataset.handle; link.hidden = false; } else { link.hidden = true; }
    agDialog.open(dlg);
  }
};

const agDialog = {
  open(dlg) { if (typeof dlg.showModal === 'function') { if (!dlg.open) dlg.showModal(); } else { dlg.setAttribute('open', ''); } },
  close(dlg) { if (typeof dlg.close === 'function' && dlg.open) dlg.close(); else dlg.removeAttribute('open'); }
};

/* ============================================================
   RESULTS TABLE (shared by the three calculators)
   ============================================================ */
function agMakeResultHTML(results, tbodyId, deleteCallback) {
  const tbody = document.getElementById(tbodyId);
  if (!tbody) return;
  const calcName = String(deleteCallback || '').split('.')[0];
  tbody.innerHTML = '';
  results.forEach((item, i) => {
    const isSundry = item.code && item.code.startsWith('SU');
    const tr = document.createElement('tr');
    tr.innerHTML = '<td>' + agThumbHTML(item.code, item.desc) + '</td>'
                 + '<td>' + agEsc(item.code || '') + '</td>'
                 + '<td>' + agEsc(item.desc) + agNoteHTML(item.code) + (item.code ? '<span class="ag-cell-code">' + agEsc(item.code) + '</span>' : '') + '</td>'
                 + '<td>' + agEsc(item.quantity) + '</td>'
                 + '<td>' + (isSundry ? '<button type="button" class="ag-del-btn" data-action="delete-result" data-calc="' + calcName + '" data-index="' + i + '" aria-label="Remove ' + agEsc(item.desc) + '">&#x2715;</button>' : '') + '</td>';
    tbody.appendChild(tr);
  });
  const summary = document.getElementById(tbodyId.replace('-tbody', '-summary'));
  if (summary) {
    summary.textContent = results.length
      ? results.length + (results.length === 1 ? ' item' : ' items') + ' calculated. Check the quantities, then add them to your Project Basket.'
      : 'No items — enter some quantities and calculate again.';
  }
  agUpgradeImages(tbody);
}

/* ============================================================
   COLOUR SWATCHES — a visual radio group that drives the
   (visually hidden) RAL select each calculator reads from.
   ============================================================ */
const AG_SWATCH_COLOURS = {
  'Textured Black (TB)': { hex: '#151515', textured: true },
  'RAL 9005': { hex: '#0A0A0A' },
  'RAL 7016': { hex: '#383E42' },
  'RAL 7021': { hex: '#2F3234' },
  'RAL 7022': { hex: '#4B4D46' },
  'RAL 7035': { hex: '#C5C7C4' },
  'RAL 7036': { hex: '#9A9697' },
  'RAL 7037': { hex: '#7A7B7A' },
  'RAL 9006': { hex: '#A5A8A6' },
  'RAL 9010': { hex: '#F1EDE1' },
  'RAL 9016': { hex: '#F1F0EA' },
  'Other Colour TBA': { tba: true }
};

const agSwatches = (function() {
  function build(select) {
    const group = document.querySelector('[data-swatches-for="' + select.id + '"]');
    if (!group) return;
    group.innerHTML = '';
    Array.from(select.options).forEach(opt => {
      if (!opt.value) return;
      const c = AG_SWATCH_COLOURS[opt.value] || {};
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ag-swatch';
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', 'false');
      btn.tabIndex = -1;
      btn.dataset.action = 'swatch';
      btn.dataset.for = select.id;
      btn.dataset.value = opt.value;
      const chip = document.createElement('span');
      chip.className = 'ag-swatch-chip' + (c.textured ? ' is-textured' : '') + (c.tba ? ' is-tba' : '');
      if (c.hex) chip.style.backgroundColor = c.hex;
      btn.appendChild(chip);
      const text = document.createElement('span');
      text.className = 'ag-swatch-text';
      const m = /^(RAL \d{4}) \((.+)\)$/.exec(opt.text);
      const code = document.createElement('span'); code.className = 'ag-swatch-code'; code.textContent = m ? m[1] : opt.text;
      text.appendChild(code);
      if (m) { const name = document.createElement('span'); name.className = 'ag-swatch-name'; name.textContent = m[2]; text.appendChild(name); }
      btn.appendChild(text);
      group.appendChild(btn);
    });
    group.addEventListener('keydown', onKey);
    select.addEventListener('change', () => sync(select.id));
    sync(select.id);
  }
  function sync(selectId) {
    const select = document.getElementById(selectId);
    const group = document.querySelector('[data-swatches-for="' + selectId + '"]');
    if (!select || !group) return;
    const btns = Array.from(group.querySelectorAll('.ag-swatch'));
    let anyChecked = false;
    btns.forEach(b => {
      const on = b.dataset.value === select.value && !!select.value;
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
      if (on) anyChecked = true;
    });
    if (!anyChecked && btns.length) btns[0].tabIndex = 0;
  }
  function choose(btn) {
    const select = document.getElementById(btn.dataset.for);
    if (!select) return;
    select.value = btn.dataset.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    sync(select.id);
    btn.focus();
  }
  function onKey(e) {
    const keys = ['ArrowRight','ArrowDown','ArrowLeft','ArrowUp','Home','End'];
    if (keys.indexOf(e.key) === -1) return;
    const btns = Array.from(e.currentTarget.querySelectorAll('.ag-swatch'));
    let i = btns.indexOf(document.activeElement);
    if (i < 0) i = 0;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') i = (i + 1) % btns.length;
    else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') i = (i - 1 + btns.length) % btns.length;
    else if (e.key === 'Home') i = 0;
    else i = btns.length - 1;
    e.preventDefault();
    choose(btns[i]);
  }
  return { build, sync, choose, init() { agQA('select[data-swatches]').forEach(build); } };
})();

/* ============================================================
   TABS (WAI-ARIA tabs pattern)
   ============================================================ */
const agTabs = (function() {
  function tabs() { return Array.from(agQA('.ag-tab[role="tab"]')); }
  function select(btn, focus) {
    tabs().forEach(t => {
      const on = t === btn;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      const panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) { panel.classList.toggle('active', on); panel.hidden = !on; }
    });
    if (focus) btn.focus();
  }
  function onKey(e) {
    const keys = ['ArrowRight','ArrowLeft','Home','End'];
    if (keys.indexOf(e.key) === -1) return;
    const list = tabs();
    let i = list.indexOf(document.activeElement);
    if (i < 0) return;
    if (e.key === 'ArrowRight') i = (i + 1) % list.length;
    else if (e.key === 'ArrowLeft') i = (i - 1 + list.length) % list.length;
    else if (e.key === 'Home') i = 0;
    else i = list.length - 1;
    e.preventDefault();
    select(list[i], true);
  }
  return { select, init() { const bar = agQ('.ag-tab-bar'); if (bar) bar.addEventListener('keydown', onKey); } };
})();

/* ============================================================
   PROJECT BASKET
   ============================================================ */
const agBasket = (function() {
  const STORAGE_KEY = 'ag_project_basket_v1';
  const basket = { gutters:[], fascia:[], copings:[] };

  /* Colour and gutter system recorded at the moment each section was added.
     Lead time is derived from these values rather than parsed out of product
     codes: sundry codes (SU1, SU3, SU9) carry no colour suffix and '-TBA'
     contains '-TB', so code parsing misreads both. */
  const meta = { gutters:null, fascia:null, copings:null };
  let projectName = '';

  /* Stocked colours. Box gutters are stocked in RAL 7016 only. */
  const STOCK_COLOURS     = ['Textured Black (TB)', 'RAL 7016'];
  const STOCK_COLOURS_BOX = ['RAL 7016'];
  const SECTIONS = [['gutters','Gutters & Downpipes'],['fascia','Fascia & Soffits'],['copings','Wall Copings']];

  function save() {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ gutters: basket.gutters, fascia: basket.fascia, copings: basket.copings, meta: meta, name: projectName })); }
    catch(e) { /* localStorage unavailable — fail silently */ }
  }
  function load() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      applyState(JSON.parse(raw));
    } catch(e) { /* corrupt data — ignore */ }
  }
  function clearStorage() { try { localStorage.removeItem(STORAGE_KEY); } catch(e) {} }

  function applyState(saved) {
    basket.gutters = (saved && Array.isArray(saved.gutters)) ? saved.gutters : [];
    basket.fascia  = (saved && Array.isArray(saved.fascia))  ? saved.fascia  : [];
    basket.copings = (saved && Array.isArray(saved.copings)) ? saved.copings : [];
    /* Baskets saved before meta existed fall back to 10 working days — the safe direction. */
    meta.gutters = (saved && saved.meta && saved.meta.gutters) || null;
    meta.fascia  = (saved && saved.meta && saved.meta.fascia)  || null;
    meta.copings = (saved && saved.meta && saved.meta.copings) || null;
    projectName = (saved && typeof saved.name === 'string') ? saved.name.slice(0, 60) : '';
  }

  function totalItems() { return basket.gutters.length + basket.fascia.length + basket.copings.length; }

  function leadDays() {
    if (totalItems() === 0) return 0;
    const hasMTO = basket.fascia.length > 0 || basket.copings.length > 0;
    let hasNonStockGutter = false;
    if (basket.gutters.length > 0) {
      const g = meta.gutters;
      if (!g || !g.ral) hasNonStockGutter = true;                 /* unknown colour — assume made to order */
      else if (g.system === 'Moulded Ogee') hasNonStockGutter = true; /* made to order in every colour */
      else {
        const stocked = (g.system === 'Box') ? STOCK_COLOURS_BOX : STOCK_COLOURS;
        hasNonStockGutter = !stocked.some(c => g.ral === c || g.ral.indexOf(c + ' ') === 0);
      }
    }
    return (hasMTO || hasNonStockGutter) ? 10 : 5;
  }

  function rowHTML(section, item, i) {
    return '<tr>'
      + '<td>' + agThumbHTML(item.code, item.desc) + '</td>'
      + '<td>' + agEsc(item.code || '') + '</td>'
      + '<td>' + agEsc(item.desc) + agNoteHTML(item.code) + (item.code ? '<span class="ag-cell-code">' + agEsc(item.code) + '</span>' : '') + '</td>'
      + '<td><span class="ag-qty-ctrl">'
      +   '<button type="button" class="ag-qty-btn" data-action="basket-qty" data-section="' + section + '" data-index="' + i + '" data-delta="-1" aria-label="Decrease quantity of ' + agEsc(item.desc) + '">&minus;</button>'
      +   '<span class="ag-qty-num">' + agEsc(item.quantity) + '</span>'
      +   '<button type="button" class="ag-qty-btn" data-action="basket-qty" data-section="' + section + '" data-index="' + i + '" data-delta="1" aria-label="Increase quantity of ' + agEsc(item.desc) + '">+</button>'
      + '</span></td>'
      + '<td><button type="button" class="ag-del-btn" data-action="basket-remove" data-section="' + section + '" data-index="' + i + '" aria-label="Remove ' + agEsc(item.desc) + '">&#x2715;</button></td>'
      + '</tr>';
  }

  function render() {
    const total = totalItems();
    const countEl = document.getElementById('ag-basket-count');
    const emptyEl = document.getElementById('ag-basket-empty');
    const sectionsEl = document.getElementById('ag-basket-sections');
    const toolsEl = document.getElementById('ag-basket-tools');
    if (countEl) countEl.textContent = total + (total === 1 ? ' item' : ' items');
    if (emptyEl) emptyEl.style.display = total === 0 ? 'block' : 'none';
    if (sectionsEl) sectionsEl.style.display = total === 0 ? 'none' : 'block';
    if (toolsEl) toolsEl.style.display = total === 0 ? 'none' : 'flex';

    SECTIONS.forEach(([key]) => {
      const wrap = document.getElementById('ag-basket-' + key);
      const tbody = document.getElementById('ag-basket-' + key + '-tbody');
      if (!wrap || !tbody) return;
      const items = basket[key];
      wrap.style.display = items.length ? 'block' : 'none';
      tbody.innerHTML = items.map((item, i) => rowHTML(key, item, i)).join('');
      agUpgradeImages(tbody);
    });

    const noteEl = document.getElementById('ag-lead-time-note');
    const days = leadDays();
    if (noteEl) {
      if (total === 0) noteEl.innerHTML = '&#9432; Lead time: Stocked colours (RAL 7016 / Textured Black) 5 working days. Fascia, soffit, copings and all other colours: 10 working days.';
      else noteEl.innerHTML = days === 5
        ? '&#9989; Overall estimated lead time: <strong>5 working days</strong> (all items are stocked colours).'
        : '&#9203; Overall estimated lead time: <strong>10 working days</strong> (one or more made-to-order or non-stocked items in basket).';
    }
    agSticky.update(total, days);

    const projEl = document.getElementById('ag-basket-project');
    const projName = document.getElementById('ag-basket-project-name');
    if (projEl && projName) {
      projName.textContent = projectName;
      projEl.style.display = (projectName && total > 0) ? 'flex' : 'none';
    }
  }

  function notice(msg) {
    const el = document.getElementById('ag-basket-notice');
    if (!el) return;
    if (!msg) { el.style.display = 'none'; el.textContent = ''; return; }
    el.textContent = msg;
    el.style.display = 'block';
  }

  function scrollTo() { const el = document.getElementById('ag-project-basket'); if (el) el.scrollIntoView({ behavior:'smooth', block:'start' }); }

  return {
    init() { load(); render(); },
    getState() { return { gutters: basket.gutters, fascia: basket.fascia, copings: basket.copings, meta: { gutters: meta.gutters, fascia: meta.fascia, copings: meta.copings }, name: projectName }; },
    getName() { return projectName; },
    setName(name) { projectName = String(name || '').trim().slice(0, 60); save(); render(); },
    setState(state, message) {
      applyState(state);
      save(); render();
      notice(message || '');
    },
    addItems(section, items, info) {
      basket[section] = JSON.parse(JSON.stringify(items)); /* deep copy */
      meta[section] = info || null;
      save(); render(); notice('');
      scrollTo();
    },
    removeItem(section, i) { basket[section].splice(i, 1); save(); render(); },
    changeQty(section, i, delta) {
      basket[section][i].quantity = Math.max(1, (basket[section][i].quantity || 1) + delta);
      save(); render();
    },
    clearAll() {
      basket.gutters = []; basket.fascia = []; basket.copings = [];
      meta.gutters = null; meta.fascia = null; meta.copings = null;
      projectName = '';
      clearStorage(); render(); notice('');
    },
    totalItems, leadDays, notice, scrollTo,
    addAllToCart() {
      const all = [...basket.gutters, ...basket.fascia, ...basket.copings];
      if (!all.length) return;
      const items = all.filter(r => AG_VARIANT_IDS[r.code]).map(r => ({ id: AG_VARIANT_IDS[r.code], quantity: r.quantity || 1 }));
      const btn = document.getElementById('ag-add-all-btn');
      if (!items.length) { alert('No valid items to add. Some items may require a colour to be selected.'); return; }
      if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }
      fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ items }) })
        .then(r => { if (!r.ok) throw new Error(r.statusText); return r.json(); })
        .then(() => {
          /* Items are now in the Shopify cart. Clear the saved basket and go to
             the full cart page — the theme's drawer does not pick up items
             added by custom code until a page renders. */
          clearStorage();
          window.location.href = '/cart';
        })
        .catch(err => {
          alert('Error adding to cart: ' + err.message);
          if (btn) { btn.innerHTML = btn.dataset.label || 'Add All to Cart'; btn.disabled = false; }
        });
    },
    printQuote() {
      let html = '<!DOCTYPE html><html lang="en"><head><meta charset="utf-8"><title>Alugutter Project Parts List</title>'
        + '<style>body{font-family:Arial,sans-serif;font-size:12px;padding:20px;color:#333} h1{font-size:18px;margin:0 0 4px} p{font-size:11px;color:#555;margin:0 0 14px} h2{font-size:13px;border-bottom:2px solid #FE881E;padding-bottom:4px;margin:18px 0 8px} table{width:100%;border-collapse:collapse;margin-bottom:10px} th,td{border:1px solid #ccc;padding:6px 8px;text-align:left;vertical-align:middle} th{background:#f0f0f0} td.img{width:48px} td.img img{width:44px;height:44px;object-fit:contain} .note{display:block;font-size:10px;color:#666;font-style:italic} .footer{margin-top:20px;font-size:11px;color:#666;border-top:1px solid #ccc;padding-top:10px} .footer ul{margin:6px 0 0 18px;padding:0}</style></head><body>';
      html += '<h1>Alugutter Project Parts List' + (projectName ? ' — ' + agEsc(projectName) : '') + '</h1>';
      html += '<p>Date: ' + new Date().toLocaleDateString('en-GB') + ' | enquiries@alugutter.co.uk | ' + agShopPhone() + '</p>';
      SECTIONS.forEach(([key, label]) => {
        if (!basket[key].length) return;
        html += '<h2>' + label + '</h2><table><tr><th></th><th>Code</th><th>Description</th><th>Qty</th></tr>';
        basket[key].forEach(r => {
          const entry = agImageEntry(r.code);
          const note = agItemNote(r.code);
          /* Prefer the colour-specific variant image when the basket has already fetched it. */
          const cached = entry && AG_IMG_CACHE[entry.handle];
          const colourSrc = cached && cached[AG_VARIANT_IDS[r.code]] ? agSizedImg(cached[AG_VARIANT_IDS[r.code]], 160) : (entry ? entry.src : '');
          html += '<tr><td class="img">' + (entry ? '<img src="' + agEsc(agAbsUrl(colourSrc)) + '" alt="">' : '') + '</td><td>' + agEsc(r.code || '') + '</td><td>' + agEsc(r.desc) + (note ? '<span class="note">' + agEsc(note) + '</span>' : '') + '</td><td>' + agEsc(r.quantity) + '</td></tr>';
        });
        html += '</table>';
      });
      html += '<div class="footer"><strong>Important Notes:</strong><ul><li>Auto-calculated quantities are estimates. Verify against site conditions before ordering.</li><li>Stocked colours (RAL 7016 / Textured Black) 5 working days. Fascia, soffit, copings and all other colours: 10 working days.</li><li>Made-to-order items are non-returnable.</li></ul></div></body></html>';
      const blob = new Blob([html], { type: 'text/html; charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const w = window.open(url, '_blank', 'width=850,height=700');
      if (w) w.addEventListener('load', function() { w.print(); URL.revokeObjectURL(url); });
    }
  };
})();

/* ============================================================
   STICKY BASKET BAR — shown while the basket has items and is
   scrolled out of view.
   ============================================================ */
const agSticky = (function() {
  let inView = true, count = 0, days = 0;
  function paint() {
    const bar = document.getElementById('ag-sticky');
    if (!bar) return;
    const show = count > 0 && !inView;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    const text = document.getElementById('ag-sticky-text');
    if (text) text.innerHTML = '<strong>Project Basket:</strong> ' + count + (count === 1 ? ' item' : ' items') + (days ? ' · estimated lead time ' + days + ' working days' : '');
  }
  return {
    init() {
      const target = document.getElementById('ag-project-basket');
      if (!target || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(entries => { inView = entries[0].isIntersecting; paint(); }, { threshold: 0.05 }).observe(target);
    },
    update(c, d) { count = c; days = d; paint(); }
  };
})();

/* ============================================================
   SHARE — encodes the basket into the page URL (#list=…) so a
   builder can send a homeowner the exact list. Items travel as
   [code, qty] pairs; a description is only included when it
   differs from the product data (e.g. colour-named touch-up paint).
   ============================================================ */
const agShare = (function() {
  function b64encode(str) {
    const bytes = new TextEncoder().encode(str);
    let bin = ''; bytes.forEach(b => { bin += String.fromCharCode(b); });
    return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function b64decode(str) {
    str = str.replace(/-/g, '+').replace(/_/g, '/');
    while (str.length % 4) str += '=';
    const bin = atob(str);
    const bytes = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    return new TextDecoder().decode(bytes);
  }
  function packItems(items) {
    return (items || []).map(r => {
      const known = AG_DESC[agCodeBase(r.code)];
      const pair = [r.code || '', r.quantity || 1];
      if (known !== r.desc) pair.push(r.desc);
      return pair;
    });
  }
  function unpackItems(list) {
    return (Array.isArray(list) ? list : []).map(p => {
      if (!Array.isArray(p)) return null;
      const code = String(p[0] || '');
      return { code, desc: p[2] != null ? String(p[2]) : (AG_DESC[agCodeBase(code)] || code), quantity: Math.max(1, parseInt(p[1], 10) || 1) };
    }).filter(Boolean);
  }
  function encode(state) {
    const s = state || agBasket.getState();
    const payload = { v: 1, g: packItems(s.gutters), f: packItems(s.fascia), c: packItems(s.copings), m: s.meta || {}, n: s.name || '' };
    return b64encode(JSON.stringify(payload));
  }
  function decode(str) {
    try {
      const p = JSON.parse(b64decode(str));
      if (!p || p.v !== 1) return null;
      return { gutters: unpackItems(p.g), fascia: unpackItems(p.f), copings: unpackItems(p.c), meta: p.m || {}, name: typeof p.n === 'string' ? p.n.slice(0, 60) : '' };
    } catch(e) { return null; }
  }
  function pageBase() { return location.href.split('#')[0].split('?')[0]; }
  function url(state) { return pageBase() + '#list=' + encode(state); }
  function plainList(state) {
    const s = state || agBasket.getState();
    const lines = [];
    if (s.name) lines.push('Project: ' + s.name, '');
    [['gutters','Gutters & Downpipes'],['fascia','Fascia & Soffits'],['copings','Wall Copings']].forEach(([k, label]) => {
      if (!s[k] || !s[k].length) return;
      lines.push(label + ':');
      s[k].forEach(r => lines.push('  ' + r.quantity + ' x ' + (r.code ? r.code + ' ' : '') + r.desc));
    });
    return lines.join('\n');
  }
  let current = null;
  function open(state) {
    current = state || null;
    const dlg = document.getElementById('ag-share-dialog');
    const link = url(current);
    document.getElementById('ag-share-url').value = link;
    document.getElementById('ag-share-status').textContent = '';
    const body = 'Here is the parts list I have put together for you. Open the link to see it on the Alugutter website and add it to your basket:\n\n' + link + '\n\n' + plainList(current);
    const name = (current && current.name) || agBasket.getName();
    document.getElementById('ag-share-email').href = 'mailto:?subject=' + encodeURIComponent('Your Alugutter parts list' + (name ? ' — ' + name : '')) + '&body=' + encodeURIComponent(body);
    const native = document.getElementById('ag-share-native');
    if (native) native.hidden = !(navigator.share);
    agDialog.open(dlg);
  }
  function copy() {
    const input = document.getElementById('ag-share-url');
    const status = document.getElementById('ag-share-status');
    const done = () => { status.textContent = 'Link copied.'; };
    const fail = () => { input.select(); status.textContent = 'Press Ctrl+C (or Cmd+C) to copy the selected link.'; };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(input.value).then(done, fail);
    else fail();
  }
  function native() {
    if (!navigator.share) return;
    navigator.share({ title: 'Alugutter parts list', text: 'Your Alugutter parts list', url: document.getElementById('ag-share-url').value }).catch(() => {});
  }
  function importFromURL() {
    const m = /[#&]list=([A-Za-z0-9_-]+)/.exec(location.hash);
    if (!m) return false;
    const state = decode(m[1]);
    if (!state) return false;
    agBasket.setState(state, 'A parts list has been shared with you. Check it over below, then press Add All to Cart when you are ready.');
    try { history.replaceState(null, '', location.pathname + location.search); } catch(e) {}
    setTimeout(() => agBasket.scrollTo(), 150);
    return true;
  }
  return { encode, decode, url, open, copy, native, importFromURL };
})();

/* ============================================================
   SAVED LISTS — named baskets kept in this browser's storage.
   ============================================================ */
const agSaved = (function() {
  const KEY = 'ag_saved_projects_v1';
  const MAX = 20;
  function all() { try { const v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch(e) { return []; } }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch(e) {} }
  function count(p) { return (p.items.gutters || []).length + (p.items.fascia || []).length + (p.items.copings || []).length; }
  function fmtDate(iso) { try { return new Date(iso).toLocaleDateString('en-GB', { day:'numeric', month:'short', year:'numeric' }); } catch(e) { return ''; } }
  function toState(p) { return { gutters: p.items.gutters || [], fascia: p.items.fascia || [], copings: p.items.copings || [], meta: p.meta || {}, name: p.name || '' }; }
  function render() {
    const list = all();
    const ul = document.getElementById('ag-saved-list');
    const empty = document.getElementById('ag-saved-empty');
    const countEl = document.getElementById('ag-saved-count');
    if (countEl) countEl.textContent = list.length;
    if (empty) empty.style.display = list.length ? 'none' : 'block';
    if (!ul) return;
    ul.innerHTML = list.map(p => '<li>'
      + '<span class="ag-saved-name">' + agEsc(p.name) + '</span>'
      + '<span class="ag-saved-meta">Saved ' + fmtDate(p.saved) + ' · ' + count(p) + (count(p) === 1 ? ' item' : ' items') + '</span>'
      + '<span class="ag-saved-actions">'
      +   '<button type="button" class="ag-link-btn" data-action="saved-load" data-id="' + agEsc(p.id) + '">Load</button>'
      +   '<button type="button" class="ag-link-btn" data-action="saved-share" data-id="' + agEsc(p.id) + '">Share</button>'
      +   '<button type="button" class="ag-link-btn is-danger" data-action="saved-delete" data-id="' + agEsc(p.id) + '">Delete</button>'
      + '</span></li>').join('');
  }
  return {
    render,
    save(name) {
      const state = agBasket.getState();
      if (!agBasket.totalItems()) return false;
      const list = all();
      const p = { id: Date.now().toString(36), name: (name || 'Untitled project').trim().slice(0, 60), saved: new Date().toISOString(), items: { gutters: state.gutters, fascia: state.fascia, copings: state.copings }, meta: state.meta };
      list.unshift(p);
      write(list); render();
      agBasket.setName(p.name);
      return p;
    },
    load(id) {
      const p = all().find(x => x.id === id);
      if (!p) return;
      agBasket.setState(toState(p), 'Loaded saved list "' + p.name + '".');
      agBasket.scrollTo();
    },
    share(id) { const p = all().find(x => x.id === id); if (p) agShare.open(toState(p)); },
    remove(id) { write(all().filter(x => x.id !== id)); render(); }
  };
})();

/* ============================================================
   BADGE HELPER
   ============================================================ */
function agUpdateBadge(id, count) {
  const el = document.getElementById(id);
  if (!el) return;
  el.textContent = count;
  el.classList.toggle('has-items', count > 0);
}

/* ============================================================
   EVENT DELEGATION — one listener for every control.
   ============================================================ */
function agHandleAction(el, e) {
  const action = el.dataset.action;
  const calc = el.dataset.calc ? AG_CALCS[el.dataset.calc] : null;
  switch (action) {
    case 'tab': agTabs.select(el); break;
    case 'swatch': agSwatches.choose(el); break;
    case 'calculate': if (calc) calc.validateAndCalculate(); break;
    case 'reset':
      if (calc) calc.resetForm();
      if (el.dataset.swatch) agSwatches.sync(el.dataset.swatch);
      agRowThumbs.refresh();
      break;
    case 'add-basket': if (calc) calc.addToBasket(); break;
    case 'print-results': if (calc) calc.printResults(); break;
    case 'delete-result': if (calc) calc.deleteItem(parseInt(el.dataset.index, 10)); break;
    case 'basket-qty': agBasket.changeQty(el.dataset.section, parseInt(el.dataset.index, 10), parseInt(el.dataset.delta, 10)); break;
    case 'basket-remove': agBasket.removeItem(el.dataset.section, parseInt(el.dataset.index, 10)); break;
    case 'clear-basket': if (confirm('Clear everything from the Project Basket?')) agBasket.clearAll(); break;
    case 'print-quote': agBasket.printQuote(); break;
    case 'add-all-to-cart': agBasket.addAllToCart(); break;
    case 'scroll-basket': agBasket.scrollTo(); break;
    case 'save-open': {
      const dlg = document.getElementById('ag-save-dialog');
      const input = document.getElementById('ag-save-name');
      input.value = agBasket.getName();
      agDialog.open(dlg);
      setTimeout(() => input.focus(), 50);
      break;
    }
    case 'saved-load': agSaved.load(el.dataset.id); break;
    case 'saved-share': agSaved.share(el.dataset.id); break;
    case 'saved-delete': if (confirm('Delete this saved list?')) agSaved.remove(el.dataset.id); break;
    case 'share-open': agShare.open(); break;
    case 'share-copy': agShare.copy(); break;
    case 'share-native': agShare.native(); break;
    case 'lightbox': agLightbox.open(el); break;
    case 'dialog-close': { const dlg = el.closest('dialog'); if (dlg) agDialog.close(dlg); break; }
  }
}

/* ============================================================
   INITIALISE
   ============================================================ */
document.addEventListener('DOMContentLoaded', function() {
  gutterCalc.init();
  fasciaCalc.init();
  copingCalc.init();

  agSwatches.init();
  agTabs.init();
  agRowThumbs.refresh();
  agSticky.init();
  agSaved.render();

  const addAll = document.getElementById('ag-add-all-btn');
  if (addAll) addAll.dataset.label = addAll.innerHTML;

  /* Row thumbnails follow the system selections. These listeners run after
     each calculator's own, so the rows are already shown or hidden. */
  ['#g-gutter-system', '#g-downpipe-system', '#g-ral-colour', '#panel-gutters .g-bracket-type', '#panel-gutters .g-clip-type'].forEach(sel => { const el = agQ(sel); if (el) el.addEventListener('change', agRowThumbs.gutter); });
  ['#f-fascia-type', '#f-soffit-type', '#f-ral-colour'].forEach(sel => { const el = agQ(sel); if (el) el.addEventListener('change', agRowThumbs.fascia); });
  const wall = agQ('#c-wall-width');
  if (wall) wall.addEventListener('input', agRowThumbs.coping);
  const cral = agQ('#c-ral-colour');
  if (cral) cral.addEventListener('change', agRowThumbs.coping);

  const root = document.getElementById('ag-estimator');
  root.addEventListener('click', e => {
    const el = e.target.closest('[data-action]');
    if (el && root.contains(el)) agHandleAction(el, e);
  });
  const saveForm = document.getElementById('ag-save-form');
  if (saveForm) saveForm.addEventListener('submit', e => {
    e.preventDefault();
    const input = document.getElementById('ag-save-name');
    const p = agSaved.save(input.value);
    if (p) {
      agDialog.close(document.getElementById('ag-save-dialog'));
      agBasket.notice('Saved as "' + p.name + '". Find it under Saved lists below.');
      const details = document.getElementById('ag-saved');
      if (details) details.open = true;
    }
  });
  /* Close a dialog when its backdrop is clicked. */
  agQA('dialog.ag-dialog').forEach(dlg => dlg.addEventListener('click', e => { if (e.target === dlg) agDialog.close(dlg); }));

  /* Restore the Project Basket (survives back-button / refresh), or import a shared list from the URL. */
  agBasket.init();
  agShare.importFromURL();
  window.addEventListener('hashchange', agShare.importFromURL);
});
